import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
// import { responceError } from '../../Global/Constant'
import ConfermationModal from '../../components/global/ConfermationModal'
import { cancelReservation } from '../../redux/actions/bookingHistoryAction'
import { useParams } from 'react-router-dom'
import { Circles } from 'react-loader-spinner'
import { useNavigate } from 'react-router-dom'
import { getPassUserDetails } from '../../redux/actions/bookingHistoryAction'
import { sortPortalPermissionByKey,isPermissionExist, phoneMasker, } from '../../utils/helper'
import { inventoryUpdateReservatino } from '../../redux/actions/widgetReservationAction'
import moment from 'moment'
import { QRCodeSVG } from 'qrcode.react'


function BookingModify(props) {
    const navigate = useNavigate()
  const {partner, ticket_id } = useParams()
  const { dispatch,notify,formType , partnerDetails} = props
  const [confermationModal, setConfermationModal] = useState(false)
//   const [cancelResponce, setCancelResponce] = useState(false)
  const [TicketItem, setTicketItem] = useState(EMPTY_ARRAY)
//   const [responce, setResponce] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [bookingDatabyID, setBookingDataById] = useState(EMPTY_OBJECT)
  const [actionTime, setActionTime] = useState(60)
  const [diffTimeBooking, setDiffTimeBooking] = useState()
  const [isTicketCancle, setIsTicketCancle] = useState(false)
  const [defaultTimeZone, setDefaultTimeZone] = useState('America/New_York')
  const [isTicketCancleMSG, setIsTicketCancleMSG] = useState('')
  const [accessPermissions, setAccessPermissions] = useState('')

// console.log(isLoading)

useEffect(() => {
  
  const getAccessPermissionData = sortPortalPermissionByKey(
    partnerDetails,
    'Restricted Permissions'
  )
  setAccessPermissions(getAccessPermissionData)
}, [EMPTY_ARRAY, partnerDetails])

  useEffect(() => {
    setDefaultTimeZone('America/New_York')
    setIsTicketCancleMSG('Reservation is canceled!')
    setActionTime(60)
    setTicketItem(ticket_id)
    // console.log(partnerDetails)
    if(partnerDetails?.id){
      getReservationDetails(ticket_id)
    }
    
    //setConfermationModal(true)
  }, [partnerDetails])

  const handleCancelTicket = (e, item) => {
      e.preventDefault()
      setTicketItem(item)
      setConfermationModal(true)
  }

  // Get ReservationDetails
  const getReservationDetails = (ticket_id) => {
    dispatch(getPassUserDetails(ticket_id)).then((res) => {
      // setIsResponce(false)
      setIsLoading(false)
        setBookingDataById(res)
        setIsTicketCancle((res?.cancelled_at !== null && res?.cancelled_at !== '') || res?.is_ticket == 2 ? true :false)
        var bookHour = moment(new Date(res?.start_timestamp)).format('YYYY-MM-DDTHH:mm:ss')
        var todayhour =  moment(new Date()).tz(`${res?.facility?.timezone ? res?.facility?.timezone: defaultTimeZone}`).format('YYYY-MM-DDTHH:mm:ss')
        let diffTime = Math.floor((new Date(bookHour).getTime() - new Date(todayhour).getTime()) / 60000)
        let actionCancel=res?.facility?.facility_configuration?.before_cancel_time ? res?.facility?.facility_configuration?.before_cancel_time:actionTime
        // let resEndDate= moment(new Date(res.end_timestamp)).format('YYYY-MM-DDTHH:mm:ss')
        // console.log(resEndDate)
        setDiffTimeBooking(diffTime)
        setActionTime(actionCancel)
    })
  }
  

  // Delete Vehicle item
  const handleDelete = () => {
	setIsLoading(true)
    if (TicketItem) {
      dispatch(cancelReservation(TicketItem)).then((res) => {
        setIsLoading(false)
        if (res?.data) {
            setIsTicketCancle(true)
            notify('success', res?.data ? res?.data :'Your ticket has been cancelled successfully!')
            getReservationDetails(ticket_id)
            setIsTicketCancleMSG('')
            if (bookingDatabyID?.facility_configurations?.is_inventory_check == '1') {
              dispatch(inventoryUpdateReservatino({ 'reservation_id': bookingDatabyID?.id, 'type': 2 })).then(() => {
              })
            }
        } else {
          setIsTicketCancle(false)
          notify('error',  res?.errors ? res?.errors?.message : 'Something went wrong, Please try again!')
        }
        // setCancelResponce(res)
      })
      setConfermationModal(false)
    }
  }

  const handleModifyTicket=(e,ticket)=>{
    navigate(`/${partner}/reservation/${ticket}`)
    //window. location. reload(true)
    // navigate(0)
  }


  return (
    <>
      <ConfermationModal
        setConfermationModal={setConfermationModal}
        confermationModal={confermationModal}
        confermationHeading="Cancel Ticket"
        confermationMessage="Are you sure you want to cancel this ticket?"
        buttonLable="Cancel Ticket"
        handleDelete={handleDelete}
      />

      {isLoading ? 
            <span className='ms-6 d-flex justify-content-center loaderdesign section dashboard'><Circles
                height="700"
                width="50"
                color="var(--bs-primary)"
                ariaLabel="circles-loading"
                visible={true}
            /></span> :
             <div className="container d-flex  align-items-center justify-content-center" style={{ minHeight: '80vh' }} >
       
        {/* new code */}
        <>
      <div className="container mb-4 mt-5" id="profileSnap">
        <div className="card mb-4 ">
          <div className='card-body'>
            <div className="row  align-items-center">
              <div className=" col-sm mb-sm-0 mb-1">
                <small className="fw-light">Hello</small>
                <h1 className="fw-bold mb-0 text-primary text-capitalize">{bookingDatabyID?.user?.name}</h1>
              </div>
              <div className="col-sm  ">
             {!isTicketCancle ? <div className='d-flex align-items-center  gap-2 justify-content-sm-end '>
                {formType=='smsForm' && isPermissionExist(accessPermissions, 'Reservation Booking Edit') ? <a  href='javascript:;' className="btn p-1 " onClick={(e) => handleModifyTicket(e,ticket_id)} > <i className='fa fa-pencil me-2'>
                </i>  Edit Reservation</a>:''}
                {diffTimeBooking>actionTime && isPermissionExist(accessPermissions, 'Reservation Booking Cancel') ?<a href='javascript:;' className="btn text-danger  p-1" onClick={(e) => handleCancelTicket(e,ticket_id)} > <i className='fa fa-trash me-2'>
                </i>  Cancel Reservation</a>:
                formType=='cancelForm' && isPermissionExist(accessPermissions, 'Reservation Booking Cancel')? <p className="text-danger">Reservation can not be canceled right now.</p>:''}
              </div> :
              <>
                <p className="text-danger  ">{isTicketCancleMSG}</p>
              </>
              }
              </div>
            </div>
            <hr/>
            <div className='row g-0 '>
            <div className='col'>
              <div className='row  row-cols-sm-3 row-cols-1'>
              <div className='col '>
                <b>Ticket Number</b>
                <p>{bookingDatabyID?.ticketech_code}</p>
              </div>
              <div className='col '>
                <b>Email ID</b>
                <p>{bookingDatabyID?.user?.email}</p>
              </div>
              <div className='col '>
                <b>Phone Number</b>
                <p>{phoneMasker(bookingDatabyID?.user?.phone_number)}</p>
              </div>
              <div className='col'>
                  <b>Facility Name</b>
                  <p>{bookingDatabyID?.facility?.full_name}</p>
              </div>
              <div className='col'>
                  <b>Parking Type</b>
                  <p>{bookingDatabyID?.parkingtype?.category}</p>
              </div>
              <div className='col'>
                  <b>Starting Parking Date/Time</b>
                  <p>{moment(bookingDatabyID?.start_timestamp).format('MM-DD-YYYY hh:mm A')}</p>
              </div>
              <div className='col'>
                  <b>Check-out Date/Time</b>
                  <p>{moment(bookingDatabyID?.end_timestamp).format('MM-DD-YYYY hh:mm A')}</p>
              </div>
              <div className='col'>

              <b>Amount</b>
              <p>${bookingDatabyID?.total}</p>
              </div>
             {bookingDatabyID?.refund_amount && <div className='col'>

              <b>Refund Amount</b>
              <p>${bookingDatabyID?.refund_amount}</p>
              </div>}
              </div>

            </div>
            <div className="col-md-3 col-12 bg-light p-4 d-flex align-items-center justify-content-center">
                          <div className='QRCenter'>
                            <QRCodeSVG
                              value={(bookingDatabyID?.thirdparty_code && bookingDatabyID?.thirdparty_code !='') ? bookingDatabyID?.thirdparty_code : bookingDatabyID?.ticketech_code}
                              //value={`${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revadminUrl : getConfigDetails()?.adminUrl}/admin/tickets?ticket_number=${ticketDetails?.reservation?.ticketech_code}`}
                              width="200px"
                              height="200px"
                            />
                          </div>
              
            </div>
            </div>

          
         
      
          </div>
        </div>

       {isPermissionExist(accessPermissions, 'Display Flight Details') ? <div className='card mb-4'>
          <div className="card-body">
            <h4 className="mb-0  mb-3"> Flight Details </h4>

            <div className='row row-cols-2  row-cols-md-5 mt-2 border-top mt-2 pt-2'>
              <div className='col border-b'>
                   <b>Departing Flight No</b>
                  <p>{bookingDatabyID?.flight_details?.departure_flight_no ? bookingDatabyID?.flight_details?.departure_flight_no : '-'}</p> 
                </div>
                <div className='col'>
                <b>Departing Airline Name</b>
                <p>{bookingDatabyID?.flight_details?.departure_airline_name ? bookingDatabyID?.flight_details?.departure_airline_name : '-'}</p> 


                </div>
                {/* <div className='col'>
                <b>Departing Date/Time</b>
                <p>{bookingDatabyID?.flight_details?.departure_time!='0000-00-00 00:00:00' ? moment(new Date(bookingDatabyID?.flight_details?.departure_time)).format('MM-DD-YYYY HH:mm:a'):'-'}</p> 
                </div> */}
                <div className='col'>
                  <b>Arrival Flight No</b>
                  <p>{bookingDatabyID?.flight_details?.arrival_flight_no ? bookingDatabyID?.flight_details?.arrival_flight_no  : '-'}</p> 
                </div>
                <div className='col'>
                  <b>Arrival Airline Name</b>
                  <p>{bookingDatabyID?.flight_details?.arrival_airline_name ? bookingDatabyID?.flight_details?.arrival_airline_name  : '-'}</p> 
                </div>
                {/* <div className='col'>
                  <b>Arrival Date/Time</b>
                  <p>{bookingDatabyID?.flight_details?.arrival_time!='0000-00-00 00:00:00' ? moment(new Date(bookingDatabyID?.flight_details?.arrival_time)).format('MM-DD-YYYY HH:mm:a'):'-'}</p> 
                </div> */}
                {/* <div className='col'>
                <b>Airline</b>
                <p>{bookingDatabyID?.flight_details?.airline_name ? bookingDatabyID?.flight_details?.airline_name:'-'}</p> 

                </div> */}

         
         </div>

            
   


          </div>
        </div>:''}

        <div className='card mb-4'>
          <div className='card-body'>
          
                <h4 className="mb-0  mb-3"> Vehicle Details </h4>
                <div className='row row-cols-2  row-cols-md-5 mt-2 border-top mt-2 pt-2 '>

                <div className='col border-b'>
                  <b>License Plate</b>
                  <p>{bookingDatabyID?.vehical_details?.license_plate_number ? bookingDatabyID?.vehical_details?.license_plate_number:'-'}</p> 

                </div>
                <div className='col'>
                <b>Vehicle Make</b>
                <p>{bookingDatabyID?.vehical_details?.make ? bookingDatabyID?.vehical_details?.make : '-' }</p> 



                  </div>
                  <div className='col'>
                    <b>Vehicle Model</b>
                    <p>{bookingDatabyID?.vehical_details?.model ? bookingDatabyID?.vehical_details?.model : '-'}</p> 
                  </div>
                  <div className='col'>
                    <b>Vehicle Color</b>
                    <p>{bookingDatabyID?.vehical_details?.color ? bookingDatabyID?.vehical_details?.color : '-'}</p> 
                  </div>

                  <div className='col'>
                   <b>Vehicle State/Province</b>
                   <p>{bookingDatabyID?.vehical_details?.state_name ? bookingDatabyID?.vehical_details?.state_name:'-'}</p>
                  </div>

              </div>


 
           
        </div>
   


  
         
        
          </div>
    

        {bookingDatabyID?.transaction ? <div className='card mb-4'>
            <div className='card-body'>
            <h4 className="mb-0  mb-3"> Payment Details </h4>

              <div className='row'>
                <div className='col-sm-4'>
                <div className="mb-1 ">
                        <label >Name on Card<span className="text-danger">*</span>
                        </label>
<p>{bookingDatabyID?.transaction?.name ? bookingDatabyID?.transaction?.name:'--'}</p>
                          {/* <input disabled={true}  name="nameoncard" id="nameoncard" title="" className="form-control" placeholder="-"value={bookingDatabyID?.transaction?.name}/> */}
                    
                      </div>
                </div>
                <div className='col-sm-4'>
                <div className="mb-1 ">
                        <label >Last 4 Digits<span className="text-danger">*</span>
                        </label>
                      
                        <p>{bookingDatabyID?.transaction?.payment_last_four}</p>
                        {/* <input disabled={true}  name="4 digit" id="digit" title="" className="form-control" placeholder="-"value={bookingDatabyID?.transaction?.payment_last_four}/> */}
                        {/* <i className='fa fa-credit-card position-absolute' style={{ top: '8px', right: '10px', pointerEvents: 'none', cursor: 'pointer' }} ></i> */}
                 
                  
                       
                      </div>
                </div>
                <div className='col-sm-4'>
                <div className="mb-3">
                  <label >Expiry Date</label>
                
                  <p>{bookingDatabyID?.transaction?.expiration}</p>
                    {/* <input disabled={true} type="text" id="expiry_date" name="expiry_date" className="form-control " value={bookingDatabyID?.transaction?.expiration} /> */}
                    {/* <i className="fa fa-calendar text-primary position-absolute" style={{ top: '8px', right: '10px', pointerEvents: 'none', cursor: 'pointer' }}>


                    </i> */}
             
                </div>
                </div>
              </div>
              {/* <div className="form-check">
              <label className="form-check-label">
  <input disabled={true} className="form-check-input" type="checkbox" value="" />
 
  I have read and agree to the ParkEngage <a href='google.com' style={{ color: '#4b90e2',}}>Terms & Conditions.</a>
  </label>
</div> */}
<hr/>

{/* <div className='d-flex justify-content-end align-items-center'>
    <buttomn className="btn btn-primary">
      Confirm and Pay
    </buttomn>
</div> */}
            </div>
          
        </div> : null }
      </div>

    </>
      </div>}
    </>
  )
}

BookingModify.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.object,
  loader: PropTypes.bool,
  notify: PropTypes.func,
  formType:PropTypes.string,
  partnerDetails: PropTypes.object,
}



BookingModify.defaulProps = {
  dispatch: noop,
  notify: noop,
  data: EMPTY_OBJECT,
  loader: PropTypes.bool,
  formType:'',
  partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps({ paymentReducer }) {
  return {
    data: paymentReducer,
  }
}
export default connect(mapStateToProps)(BookingModify)
